<div>
  <div class="title tw-items-center" mat-dialog-title>
    <p *ngIf="template.id" class="title-content">Update Email Template</p>
    <p *ngIf="!template.id" class="title-content">New Email Template</p>
    <mat-icon class="close tw-cursor-pointer" aria-hidden="false" mat-dialog-close>close</mat-icon>
  </div>
  <mat-dialog-content>
    <div class="tw-pt-3">
      <mat-form-field class="tw-w-full">
        <mat-label>Template Title</mat-label>
        <input matInput name="title" [(ngModel)]="template.title" required (keyup)="titleSubjectChange()">
      </mat-form-field>
      <mat-form-field class="tw-w-full">
        <mat-label>Email Subject</mat-label>
        <input matInput name="subject" [(ngModel)]="template.subject" required (keyup)="titleSubjectChange()">
      </mat-form-field>
    </div>
    <quill-editor
      format="html"
      [(ngModel)]="template.content"
      (onEditorCreated)="handleEditorCreated($event)"
      (onSelectionChanged)="handleSelectionChange($event.range)"
      (onContentChanged)="handleContentChange()"
      (keydown.enter)="handleEnterSelectionLocation()">
      <div quill-editor-toolbar id="tool-container">
        <button matTooltip="Bold Text" id="quill-buttons" class="ql-bold"></button>
        <button matTooltip="Italic Text" id="quill-buttons" class="ql-italic"></button>
        <button matTooltip="Ordered List" id="quill-buttons" class="ql-list" value="ordered"></button>
        <button matTooltip="Bullet List" id="quill-buttons" class="ql-list" value="bullet"></button>
        <button matTooltip="Hyperlink" id="quill-buttons" class="ql-link"></button>
        <button
          style="display: none;"
          mat-button
          id="message-add-emoji"
          [matMenuTriggerFor]="emojiMart"
          matTooltip="Pick your emoji...">
          <i class="fa fa-lg fa-smile-o message-emoji-icon"></i>
          <mat-menu class="message-emoji-mart-mat-menu" #emojiMart>
            <emoji-mart
              emoji="point_up"
              title="Pick your emoji..."
              (click)="$event.stopPropagation()"
              (emojiClick)="handleEmoji($event)">
            </emoji-mart>
          </mat-menu>
        </button>
        <button
          class="tw-leading-none template-var-btn"
          mat-button
          [matMenuTriggerFor]="templateVariables"
          matTooltip="Variables">
          <span class="tw-font-bold" [innerText]="'Insert {}'"></span>
          <mat-menu #templateVariables class="template-var-menu">
            <button
              *ngFor="let variable of variables$ | async"
              mat-menu-item
              (click)="handleInsertVariable(variable)">
              {{ variable.label }}
            </button>
          </mat-menu>
        </button>
      </div>
    </quill-editor>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-footer-container" align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      class="tw-ml-2"
      [disabled]="saveButtonDisabled || (loading$ | async)"
      (click)="saveTemplate()">
      <span *ngIf="!(loading$ | async)">Save</span>
      <mat-spinner
        *ngIf="(loading$ | async)"
        diameter="24"
        style="display: inline-block; height: 24px; width: 24px">
      </mat-spinner>
    </button>
  </mat-dialog-actions>
</div>
